import React, { useEffect, useState } from "react"
import { getCategories } from "../../utils/ApiRequests"
import { getApiErrorMessage } from "../../utils/ApiUtils"
import DisplayCategory from "../DisplayCategory/DisplayCategory"
import ModalContainer from "../ModalContainer/ModalContainer"

const DashboardChecklist = ({ registry }) => {
  const [showModal, setShowModal] = useState(false)
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedCategory, setSelectedCategory] = useState({})

  useEffect(() => {
    getCategories()
      .then(res => {
        setCategories(res.data?.data)
        setLoading(false)
      })
      .catch(err => {
        getApiErrorMessage(err.response)
        setLoading(false)
      })
  }, [])

  return (
    <div className=" mt-5">
      <h1 className="font-medium text-lg">Recommendations</h1>
      <div className="overflow-auto py-5 whitespace-nowrap bg-sbg-white hide-scrollbar">
        {showModal && (
          <ModalContainer>
            <DisplayCategory
              closeModal={() => setShowModal(false)}
              categoryId={selectedCategory}
              registryId={registry}
            />
          </ModalContainer>
        )}
        {!loading &&
          categories.map(c => (
            <div
              className="h-52 w-40 border border-sbg-grey rounded-2xl py-4 px-2 mr-5 inline-block bg-center bg-no-repeat bg-cover cursor-pointer bg-opacity-10"
              style={{ backgroundImage: `url(${c.icon_image})` }}
              key={c.name}
              onClick={() => {
                setShowModal(true)
                setSelectedCategory(c._id)
              }}
            >
              <div className="flex h-full flex-col justify-center">
                <p className="text-center ">{c.name}</p>
                <h1 className="self-center mt-3 ">+</h1>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

export default DashboardChecklist
